export default __webpack_public_path__ + "static/media/carwash-fill.5a1a90ee.svg";